import { useProduct } from "~/contexts/product-context";
import { actionErrored } from "~/utils/status";
import { getActionsByType } from "~/integrations/firebase/collections";
import { FinalKeywords } from "./components/final-keywords/final-keywords";
import { KeywordsError } from "./keywords-error";
import { UnifiedKeywordsTable } from "./components/unified-keywords-table/unified-keywords-table";
import { useKeywordGeneration } from "./hooks/use-keyword-generation";

interface KeywordsTabProps {
  showReasoning?: boolean;
}

export const KeywordsTab = ({ showReasoning = false }: KeywordsTabProps) => {
  const { product } = useProduct();
  const { generateKeywords } = useKeywordGeneration();

  if (!product) {
    return null;
  }

  const { keywords: keywordsActions } = getActionsByType(product);
  const action = keywordsActions?.generate;
  const isError = actionErrored(action);

  const handleGenerate = async () => {
    await generateKeywords();
  };

  return (
    <div className="flex flex-row gap-4 h-full">
      {isError ? (
        <KeywordsError
          onGenerate={handleGenerate}
          statusCode={action?.statusCode}
        />
      ) : (
        <UnifiedKeywordsTable showReasoning={showReasoning} />
      )}
      <FinalKeywords showReasoning={showReasoning} />
    </div>
  );
};
